// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  API_BASE_PATH: "https://api.cykelmakker.danishsoftware.com",
  S3_BASE_PATH: "https://s3-eu-west-1.amazonaws.com/rma.trafficbeam/",
  GOOGLE_API: "AIzaSyCZr9UnQrA-gb-3OEUG4A67YK1Sfyvz6kk",
  firebase: {
    apiKey: "AIzaSyDvfsLcUEDXOSSruxSnghvOqebgv5m5Hbk",
    authDomain: "cykelmakker-f7867.firebaseapp.com",
    projectId: "cykelmakker-f7867",
    storageBucket: "cykelmakker-f7867.appspot.com",
    messagingSenderId: "460605130251",
    appId: "1:460605130251:web:28285f43c44b7afb92a90e",
    measurementId: "G-XWFJXBM2QL",
  },
};
